import { render, staticRenderFns } from "./App.vue?vue&type=template&id=68c83534"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.3_webpack@5.80.0__lodash@4.17.21_prettier@2.8.8_vue-t_eaa518b09bbfa5d9a40d7deab2aad903/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports